import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser } from '#validation';
export const PartnerOrganizationApiKeyResponseSchema = z.object({
    id: z.number(),
    partnerOrganizationId: z.string(),
    keyPrefix: z.string(),
    label: z.string().nullable(),
    createdAt: dateParser(),
    expiresAt: dateParser().nullable(),
    cidr: z.array(z.string()).nullable(),
    permissions: z.array(z.string()).nullable(),
});
export class PartnerOrganizationApiKeyResponseDto extends createZodDto(PartnerOrganizationApiKeyResponseSchema) {
}
export const CreatePartnerOrganizationApiKeyResponseSchema = PartnerOrganizationApiKeyResponseSchema.extend({
    key: z.string(),
});
export class CreatePartnerOrganizationApiKeyResponseDto extends createZodDto(CreatePartnerOrganizationApiKeyResponseSchema) {
}
